module.exports = __webpack_public_path__ + "img/jucai3.66be7792.jpg";